import {
  Col,
  colors,
  IAvailableIcons,
  Icon,
  ISpaceProps,
  ITitleProps,
  Space,
  Title,
} from 'common-components';
import { css } from '@emotion/react';
import { GlobalOutlined } from '@ant-design/icons';
import { PropsWithChildren } from 'react';

type IItemWithAvatarPropsType = {
  title?: string
  titleProps?: ITitleProps
  iconName?: IAvailableIcons
  iconColor?: string
  containerProps?: ISpaceProps
};
const ItemWithAvatar = ({
  title,
  titleProps = {},
  containerProps = {},
  iconName,
  iconColor,
  children,
}: PropsWithChildren<IItemWithAvatarPropsType>) => {
  return (
    <Space size={12} align={'center'} style={{ width: '100%' }} {...containerProps}>
      <Col
        css={css`
          background: ${iconColor || colors.cyan100};
          border-radius: 200px;
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        {iconName ? <Icon icon={iconName} /> : <GlobalOutlined style={{ fontSize: 32 }} />}
      </Col>
      <Space size={4} orientation={'vertical'}>
        {!!title && (
          <Title style={{ fontSize: 16, lineHeight: '24px', fontWeight: 500, color: colors.gray900 }} {...titleProps}>
            {title}
          </Title>
        )}
        {children}
      </Space>
    </Space>
  );
};

export default ItemWithAvatar;
